import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestSection() {
  const latestComics = [...comics].sort((a, b) =>
    new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 12);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
            最近更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最新更新的漫画章节，追更不迷路</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {latestComics.map((comic) => (
            <div key={comic.id} className="flex justify-center">
              <ComicCard
                id={comic.id}
                title={comic.title}
                author={comic.author}
                cover={comic.cover}
                category={comic.category}
                categories={comic.categories}
                rating={comic.rating}
                views={comic.views}
                status={comic.status}
                chapters={comic.chapters}
                updatedAt={comic.updatedAt}
                size="md"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}